import { IS_PROD } from 'modules/common/const';
import { OChainId } from './chainIDs';

export const BFF_BASE_URL_STAGE = 'https://bff.stage.lombard-fi.com';
export const BFF_BASE_URL_PROD = 'https://bff.prod.lombard-fi.com';

export const ETH_NETWORK_BY_ENV = IS_PROD
  ? OChainId.ethereum
  : OChainId.holesky;

export const SONIC_NETWORK_BY_ENV = OChainId.sonic;

export const OLstvToken = {
  sonicLBTCv: 'sonicLBTCv',
} as const;
